module.exports = __webpack_public_path__ + "static/media/illu-serviette.e4c21b37.png";